import { Box, Typography } from "@mui/material";
import React from "react";
import Translations from "../../lang/en/pages.json";
import { formatNumberWithSuffix } from "../../utils";
const ComparativeCaseAnalysis: React.FC<{
  number1: number;
  number2: number;
}> = ({ number1, number2 }) => {
  const calcSize = (num: number, total: number) => {
    if (total === 0) {
      return 0;
    }
    const maxSize = 160;
    const minSize = 80;
    const normalizedSize = (num / total) * (maxSize - minSize) + minSize;
    return Math.min(Math.max(normalizedSize, minSize), maxSize);
  };

  return (
    <Box sx={{ height: "20%", maxWidth: 600, p: 4 }}>
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: 195,
          mx: "auto",
          alignItems: "center",
          textAlign: "center",
          right: "20%",
          "&::before": {
            content: '""',
            display: "block",
            paddingTop: "100%",
          },
        }}
      >
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: "#b388ff",
            borderRadius: "50%",
            top: 0,
            right: `${calcSize(number1, number1 + number2) / 3}px`,
            left: "auto",
            width: calcSize(number1, number1 + number2),
            height: calcSize(number1, number1 + number2),
            boxShadow: 3,
          }}
        >
          <Typography variant="h6" sx={{ color: "white", fontWeight: 600 }}>
            {formatNumberWithSuffix(number1)}
          </Typography>
        </Box>

        <Box
          sx={{
            position: "absolute",
            border: "6px solid white",
            top: 0,
            right: 0,
            left: "auto",
            width: calcSize(number2, number1 + number2),
            height: calcSize(number2, number1 + number2),
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: "#4caf50",
            borderRadius: "50%",
            boxShadow: 3,
          }}
        >
          <Typography variant="h6" sx={{ color: "white", fontWeight: 600 }}>
            {formatNumberWithSuffix(number2)}
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 2,
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box
            sx={{
              width: 16,
              height: 16,
              borderRadius: "50%",
              bgcolor: "#b388ff",
              boxShadow: 1,
            }}
          />
          <Typography
            whiteSpace={"nowrap"}
            variant="caption"
            color="text.secondary"
          >
            {
              Translations.pages.dashboard_page.tabs.overview
                .comparative_case_analysis.cases_analyzed
            }
          </Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box
            sx={{
              width: 16,
              height: 16,
              borderRadius: "50%",
              bgcolor: "#4caf50",
              boxShadow: 1,
            }}
          />
          <Typography
            whiteSpace={"nowrap"}
            variant="caption"
            color="text.secondary"
          >
            {
              Translations.pages.dashboard_page.tabs.overview
                .comparative_case_analysis.highly_cases_analyzed
            }
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ComparativeCaseAnalysis;
